import { render, staticRenderFns } from "./CompanyServiceFees.vue?vue&type=template&id=59bbd899"
import script from "./CompanyServiceFees.vue?vue&type=script&lang=js"
export * from "./CompanyServiceFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports